module.exports = __webpack_public_path__ + "fonts/fontello.0e640f92.ttf";